module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-audience-form"
  }, [_c('NlFilterBar', {
    attrs: {
      "current-filters": _vm.filters
    },
    on: {
      "filters-received": _vm.applyAiFilters,
      "generating-start": function($event) {
        _vm.loading = true
      },
      "generating-abort": function($event) {
        _vm.loading = false
      }
    }
  }), _vm._v(" "), (_vm.aiIgnored.length) ? _c('div', {
    staticClass: "not-enforced-note",
    staticStyle: {
      "margin": "-6px 0 12px"
    }
  }, _vm._l((_vm.aiIgnored), function(text, i) {
    return _c('div', {
      key: i
    }, [_vm._v(_vm._s(text))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cust-bar"
  }, [_c('div', {
    staticClass: "cust-field"
  }, [_c('span', {
    staticClass: "cust-label required"
  }, [_vm._v("Customer")]), _vm._v(" "), _c('treeselect', {
    staticClass: "cust-select",
    attrs: {
      "clearable": false,
      "placeholder": "--Choose a Customer--",
      "options": _vm.customerOptions
    },
    on: {
      "input": _vm.handleCustomerInput
    },
    model: {
      value: (_vm.filters.customer),
      callback: function($$v) {
        _vm.$set(_vm.filters, "customer", $$v)
      },
      expression: "filters.customer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cust-field"
  }, [_c('span', {
    staticClass: "cust-label"
  }, [_vm._v("Country")]), _vm._v(" "), _c('treeselect', {
    staticClass: "cust-select",
    attrs: {
      "placeholder": "--Choose a Country--",
      "options": _vm.countryOptions
    },
    on: {
      "input": _vm.handleCountryInput
    },
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cust-meta"
  }, [(_vm.filters.customer && _vm.filters.country) ? _c('span', {
    staticClass: "cust-context-pill"
  }, [_vm._v(_vm._s(_vm.filters.customer) + " · " + _vm._s(_vm.filters.country))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "cust-hint"
  }, [_vm._v("Customer and country filter each other")]), _vm._v(" "), (_vm.submitted && !_vm.filters.customer) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a customer.")]) : (_vm.submitted && !_vm.filters.country_id) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a country.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "builder-layout"
  }, [_c('div', {
    staticClass: "builder-left"
  }, [_c('div', {
    staticClass: "filter-panel"
  }, [_c('div', {
    staticClass: "fp-hdr"
  }, [_c('div', {
    staticClass: "fp-title"
  }, [_vm._v("\n            Audience Filters\n            "), _c('span', {
    staticClass: "ai-badge",
    class: _vm.aiPopulatedCount ? 'ai-badge-ai' : 'ai-badge-manual'
  }, [_vm._v("\n              " + _vm._s(_vm.aiPopulatedCount ? (_vm.aiPopulatedCount + " field(s) AI populated") : 'Manual') + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "fp-hdr-actions"
  }, [_c('a', {
    staticClass: "fp-action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setAllSections(false)
      }
    }
  }, [_vm._v("Expand all")]), _vm._v(" "), _c('a', {
    staticClass: "fp-action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setAllSections(true)
      }
    }
  }, [_vm._v("Collapse all")]), _vm._v(" "), _c('a', {
    staticClass: "fp-action fp-action-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilters.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear all")])])]), _vm._v(" "), _c('div', {
    staticClass: "fp-body"
  }, [_c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.programme,
      'ai-updated': _vm.aiFlash.programme
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('programme')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Programme")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.programme),
      expression: "!collapsed.programme"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "filter-row cols-2"
  }, [_c('div', {
    staticClass: "fg"
  }, [_vm._m(0), _vm._v(" "), _c('treeselect', {
    attrs: {
      "clearable": false,
      "placeholder": "--Choose a Journey--",
      "options": _vm.journeyOptions,
      "disabled": !_vm.filters.customer || !_vm.filters.country
    },
    on: {
      "input": _vm.handleJourneyInput
    },
    model: {
      value: (_vm.filters.journey),
      callback: function($$v) {
        _vm.$set(_vm.filters, "journey", $$v)
      },
      expression: "filters.journey"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.filters.journey) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a journey.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "fg"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "chip-wrap"
  }, _vm._l((_vm.channelOptions), function(channel) {
    return _c('div', {
      key: channel.value,
      staticClass: "fchip",
      class: {
        sel: _vm.filters.channels.includes(channel.value)
      },
      on: {
        "click": function($event) {
          return _vm.toggleChip('channels', channel.value)
        }
      }
    }, [_c('span', {
      staticClass: "chk"
    }), _vm._v(_vm._s(channel.label) + "\n                    ")])
  }), 0), _vm._v(" "), (_vm.submitted && !_vm.filters.channels.length) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose at least one platform.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "fg",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "funnel-range-row"
  }, [_c('div', {
    staticClass: "funnel-range-col"
  }, [_c('div', {
    staticClass: "funnel-range-label"
  }, [_vm._v("From (earliest stage reached)")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-select",
    on: {
      "change": _vm.handleFunnelFromInput
    },
    model: {
      value: (_vm.filters.funnelFrom),
      callback: function($$v) {
        _vm.$set(_vm.filters, "funnelFrom", $$v)
      },
      expression: "filters.funnelFrom"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Reached chatbot")]), _vm._v(" "), _vm._l((_vm.funnelStageOptions.slice(1)), function(stage) {
    return _c('option', {
      key: stage.value,
      domProps: {
        "value": stage.value
      }
    }, [_vm._v(_vm._s(stage.label))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "funnel-range-sep"
  }, [_vm._v("→")]), _vm._v(" "), _c('div', {
    staticClass: "funnel-range-col"
  }, [_c('div', {
    staticClass: "funnel-range-label"
  }, [_vm._v("To (stage not reached)")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-select",
    on: {
      "change": function($event) {
        _vm.markManual('funnelTo');
        _vm.maybeGenerateName()
      }
    },
    model: {
      value: (_vm.filters.funnelTo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "funnelTo", $$v)
      },
      expression: "filters.funnelTo"
    }
  }, [_c('option', {
    attrs: {
      "value": "any"
    }
  }, [_vm._v("Any — no upper limit")]), _vm._v(" "), _vm._l((_vm.funnelToOptions), function(stage) {
    return _c('option', {
      key: stage.value,
      domProps: {
        "value": stage.value
      }
    }, [_vm._v(_vm._s(stage.label))])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "funnel-hint",
    domProps: {
      "innerHTML": _vm._s(_vm.funnelHint)
    }
  }), _vm._v(" "), (_vm.funnelRangeWarning) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("\"To\" stage must be later than \"From\" stage.")]) : _vm._e(), _vm._v(" "), (_vm.filters.journey && !_vm.journeyStageMapping.length) ? _c('span', {
    staticClass: "not-enforced-note"
  }, [_vm._v("\n                  This journey has no stage mapping configured in Journey Settings yet — this range won't be applied to the count until it is.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fg",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Date entered "), _c('span', {
    staticClass: "funnel-from-label"
  }, [_vm._v(_vm._s(_vm.funnelFromLabel))]), _vm._v(" "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(optional)")])]), _vm._v(" "), _c('div', {
    staticClass: "date-range-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.stageEnteredFrom),
      expression: "filters.stageEnteredFrom"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.stageEnteredFrom)
    },
    on: {
      "change": function($event) {
        return _vm.markManual('stageEnteredFrom')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "stageEnteredFrom", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-sep"
  }, [_vm._v("to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.stageEnteredTo),
      expression: "filters.stageEnteredTo"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.stageEnteredTo)
    },
    on: {
      "change": function($event) {
        return _vm.markManual('stageEnteredTo')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "stageEnteredTo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fp-action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.filters.stageEnteredFrom = '';
        _vm.filters.stageEnteredTo = '';
        _vm.markManual('stageEnteredFrom');
        _vm.markManual('stageEnteredTo')
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), (_vm.stageEnteredWarning) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("\"From\" date must be before \"To\" date.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filter-row cols-2",
    staticStyle: {
      "margin-top": "14px",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "fg"
  }, [_vm._m(3), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a stage--",
      "options": _vm.conversationStageOptionsForJourney,
      "disabled": !_vm.filters.journey,
      "loading": _vm.loadingJourneyConversations
    },
    on: {
      "input": _vm.handleConversationStageInput
    },
    model: {
      value: (_vm.filters.conversationStageOption),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conversationStageOption", $$v)
      },
      expression: "filters.conversationStageOption"
    }
  }), _vm._v(" "), (_vm.filters.journey && !_vm.conversationStageOptionsForJourney.length && !_vm.loadingJourneyConversations) ? _c('span', {
    staticClass: "not-enforced-note"
  }, [_vm._v("\n                    Couldn't load this journey's conversation stages.\n                  ")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.demographics,
      'ai-updated': _vm.aiFlash.demographics
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('demographics')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Demographics")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.demographics),
      expression: "!collapsed.demographics"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "filter-row cols-2"
  }, [_c('div', {
    staticClass: "fg"
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Age range")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-row"
  }, [_c('nv-select', {
    staticClass: "form-select",
    on: {
      "change": function($event) {
        return _vm.markManual('minAge')
      }
    },
    model: {
      value: (_vm.filters.minAge),
      callback: function($$v) {
        _vm.$set(_vm.filters, "minAge", $$v)
      },
      expression: "filters.minAge"
    }
  }, _vm._l((_vm.ageOptions), function(age) {
    return _c('option', {
      key: 'min-' + age.id,
      domProps: {
        "value": age.id
      }
    }, [_vm._v(_vm._s(age.label))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "range-sep"
  }, [_vm._v("to")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-select",
    on: {
      "change": function($event) {
        return _vm.markManual('maxAge')
      }
    },
    model: {
      value: (_vm.filters.maxAge),
      callback: function($$v) {
        _vm.$set(_vm.filters, "maxAge", $$v)
      },
      expression: "filters.maxAge"
    }
  }, _vm._l((_vm.ageOptions), function(age) {
    return _c('option', {
      key: 'max-' + age.id,
      domProps: {
        "value": age.id
      }
    }, [_vm._v(_vm._s(age.label))])
  }), 0)], 1), _vm._v(" "), (_vm.ageWarning) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("\"Age From\" must be less than \"Age To\".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fg"
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "chip-wrap"
  }, [_vm._l((_vm.genderOptions), function(gender) {
    return _c('div', {
      key: gender.value,
      staticClass: "fchip",
      class: {
        sel: _vm.filters.gender.includes(gender.value)
      },
      on: {
        "click": function($event) {
          return _vm.toggleChip('gender', gender.value)
        }
      }
    }, [_c('span', {
      staticClass: "chk"
    }), _vm._v(_vm._s(gender.label) + "\n                    ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "fchip",
    class: {
      sel: !_vm.filters.gender.length
    },
    on: {
      "click": function($event) {
        _vm.filters.gender = [];
        _vm.markManual('gender')
      }
    }
  }, [_c('span', {
    staticClass: "chk"
  }), _vm._v("All\n                    ")])], 2)])])])]), _vm._v(" "), _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.geography,
      'ai-updated': _vm.aiFlash.geography
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('geography')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Geography")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.geography),
      expression: "!collapsed.geography"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "filter-row cols-2"
  }, [_c('div', {
    staticClass: "fg"
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("State / Province "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v(_vm._s(_vm.filters.country || ''))])]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "All",
      "options": _vm.stateOptions,
      "disabled": !_vm.filters.country
    },
    on: {
      "input": _vm.handleStateInput
    },
    model: {
      value: (_vm.filters.stateProvince),
      callback: function($$v) {
        _vm.$set(_vm.filters, "stateProvince", $$v)
      },
      expression: "filters.stateProvince"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fg"
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("City / LGA")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "All",
      "options": _vm.cityOptions,
      "disabled": !_vm.filters.stateProvince
    },
    on: {
      "input": function($event) {
        return _vm.markManual('cityLga')
      }
    },
    model: {
      value: (_vm.filters.cityLga),
      callback: function($$v) {
        _vm.$set(_vm.filters, "cityLga", $$v)
      },
      expression: "filters.cityLga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fg-sub-note"
  }, [_vm._v("Populated by selected state")])], 1)]), _vm._v(" "), (_vm.filters.country && !_vm.stateOptions.length) ? _c('span', {
    staticClass: "not-enforced-note"
  }, [_vm._v("\n                No state/province with sampled users was found for this country.\n              ")]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.behaviour,
      'ai-updated': _vm.aiFlash.behaviour
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('behaviour')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Behaviour")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.behaviour),
      expression: "!collapsed.behaviour"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "fg",
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Inactivity window")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-row"
  }, [_c('nv-select', {
    staticClass: "form-select",
    on: {
      "change": function($event) {
        return _vm.markManual('recencyFrom')
      }
    },
    model: {
      value: (_vm.filters.recencyFrom),
      callback: function($$v) {
        _vm.$set(_vm.filters, "recencyFrom", $$v)
      },
      expression: "filters.recencyFrom"
    }
  }, _vm._l((_vm.recencyFromOptions), function(r) {
    return _c('option', {
      key: 'from-' + r.id,
      domProps: {
        "value": r.id
      }
    }, [_vm._v(_vm._s(r.label))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "range-sep"
  }, [_vm._v("to")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-select",
    on: {
      "change": function($event) {
        return _vm.markManual('recencyTo')
      }
    },
    model: {
      value: (_vm.filters.recencyTo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "recencyTo", $$v)
      },
      expression: "filters.recencyTo"
    }
  }, _vm._l((_vm.recencyOptions), function(r) {
    return _c('option', {
      key: 'to-' + r.id,
      domProps: {
        "value": r.id
      }
    }, [_vm._v(_vm._s(r.label))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "range-sep"
  }, [_vm._v("inactive")])], 1), _vm._v(" "), (_vm.recencyWarning) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("\"Inactive From\" must be less than \"Inactive To\".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "barriers-row"
  }, [_c('span', [_vm._v("⚠")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("Barrier filters unavailable — no data collected for this journey yet.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/user-journey/settings"
    }
  }, [_vm._v("Enable in Journey Settings ›")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.keywords,
      'ai-updated': _vm.aiFlash.keywords
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('keywords')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Entry Keywords")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.keywords),
      expression: "!collapsed.keywords"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "fg"
  }, [_vm._m(4), _vm._v(" "), _c('treeselect', {
    key: 'keywords-' + (_vm.filters.country || 'none'),
    attrs: {
      "multiple": true,
      "flat": true,
      "limit": 6,
      "limit-text": function (count) { return ("+" + count + " more"); },
      "max-height": 260,
      "options": _vm.keywordTreeOptions,
      "disabled": !_vm.filters.country,
      "placeholder": _vm.filters.country ? ("Search and select from " + (_vm.keywordOptions.length) + " keywords…") : 'Choose a customer/country to load keywords',
      "no-options-text": 'No keywords found for this country.'
    },
    on: {
      "input": function($event) {
        return _vm.markManual('entryKeywords')
      }
    },
    model: {
      value: (_vm.filters.entryKeywords),
      callback: function($$v) {
        _vm.$set(_vm.filters, "entryKeywords", $$v)
      },
      expression: "filters.entryKeywords"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fg-sub-note"
  }, [_vm._v("Keywords are scoped to the selected country. Users who entered via any selected keyword are included.")])], 1)])]), _vm._v(" "), (_vm.readinessStageOptions.length) ? _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.readiness,
      'ai-updated': _vm.aiFlash.readiness
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('readiness')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Readiness")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.readiness),
      expression: "!collapsed.readiness"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "fg"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "chip-wrap"
  }, _vm._l((_vm.readinessStageOptions), function(opt) {
    return _c('div', {
      key: opt,
      staticClass: "fchip",
      class: {
        sel: _vm.filters.readiness.includes(opt)
      },
      on: {
        "click": function($event) {
          return _vm.toggleChip('readiness', opt)
        }
      }
    }, [_c('span', {
      staticClass: "chk"
    }), _vm._v(_vm._s(opt) + "\n                  ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "not-enforced-note"
  }, [_vm._v("Not yet enforced in the live count — no data model links readiness responses back to users today; captured on the saved segment regardless.")])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.proximity,
      'ai-updated': _vm.aiFlash.proximity
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('proximity')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Proximity to Facility")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.proximity),
      expression: "!collapsed.proximity"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "fg",
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._m(6), _vm._v(" "), _c('treeselect', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "placeholder": "All offerings",
      "multiple": true,
      "options": _vm.offeringOptions,
      "disabled": !_vm.filters.country
    },
    on: {
      "input": _vm.onOfferingsChange
    },
    model: {
      value: (_vm.filters.offeringIds),
      callback: function($$v) {
        _vm.$set(_vm.filters, "offeringIds", $$v)
      },
      expression: "filters.offeringIds"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fg",
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "date-range-row",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [(_vm.filters.customer) ? _c('label', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "6px",
      "font-size": "12px",
      "color": "#616161",
      "cursor": "pointer",
      "white-space": "nowrap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.facilityScopeToCustomer),
      expression: "filters.facilityScopeToCustomer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filters.facilityScopeToCustomer) ? _vm._i(_vm.filters.facilityScopeToCustomer, null) > -1 : (_vm.filters.facilityScopeToCustomer)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.filters.facilityScopeToCustomer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filters, "facilityScopeToCustomer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filters, "facilityScopeToCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filters, "facilityScopeToCustomer", $$c)
        }
      }, _vm.onFacilityScopeChange]
    }
  }), _vm._v("\n                    Limit to " + _vm._s(_vm.filters.customer) + "'s facilities\n                  ")]) : _vm._e()]), _vm._v(" "), _c('treeselect', {
    key: 'facility-' + (_vm.filters.country || 'none') + '-' + (_vm.filters.offeringIds || []).join('_') + '-' + _vm.filters.facilityScopeToCustomer,
    attrs: {
      "placeholder": "Search facilities…",
      "multiple": true,
      "options": _vm.facilityOptions,
      "async": true,
      "load-options": _vm.loadFacilityOptions,
      "disabled": !_vm.filters.country
    },
    on: {
      "input": function($event) {
        return _vm.markManual('facilityIds')
      }
    },
    model: {
      value: (_vm.filters.facilityIds),
      callback: function($$v) {
        _vm.$set(_vm.filters, "facilityIds", $$v)
      },
      expression: "filters.facilityIds"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fg"
  }, [_c('div', {
    staticClass: "fg-lbl",
    class: {
      required: _vm.hasProximityConstraint
    }
  }, [_vm._v("Radius")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-row"
  }, [_c('nv-select', {
    staticClass: "form-select",
    staticStyle: {
      "max-width": "170px"
    },
    on: {
      "change": function($event) {
        return _vm.markManual('radiusKm')
      }
    },
    model: {
      value: (_vm.filters.radiusKm),
      callback: function($$v) {
        _vm.$set(_vm.filters, "radiusKm", $$v)
      },
      expression: "filters.radiusKm"
    }
  }, _vm._l((_vm.radiusOptions), function(r) {
    return _c('option', {
      key: 'radius-' + r.id,
      domProps: {
        "value": r.id
      }
    }, [_vm._v(_vm._s(r.label))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "range-sep"
  }, [_vm._v("of matching facilities")])], 1), _vm._v(" "), (_vm.submitted && _vm.proximityRadiusWarning) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Select a radius — it's required once a facility, offering, or client filter is set.")]) : _vm._e(), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('section', {
    staticClass: "filter-section",
    class: {
      collapsed: _vm.collapsed.exclusions,
      'ai-updated': _vm.aiFlash.exclusions
    }
  }, [_c('div', {
    staticClass: "fs-header",
    on: {
      "click": function($event) {
        return _vm.toggleSection('exclusions')
      }
    }
  }, [_c('span', {
    staticClass: "fs-title-text"
  }, [_vm._v("Exclusions")]), _vm._v(" "), _c('span', {
    staticClass: "fs-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed.exclusions),
      expression: "!collapsed.exclusions"
    }],
    staticClass: "fs-body"
  }, [_c('div', {
    staticClass: "fg",
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Exclude users already in these segments")]), _vm._v(" "), _c('div', {
    staticClass: "exclusion-checklist"
  }, [(!_vm.otherSegments.length) ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("No other saved segments yet.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.otherSegments), function(segment) {
    return _c('div', {
      key: segment.id,
      staticClass: "exclusion-row"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filters.excludeSegmentIds),
        expression: "filters.excludeSegmentIds"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": segment.id,
        "checked": Array.isArray(_vm.filters.excludeSegmentIds) ? _vm._i(_vm.filters.excludeSegmentIds, segment.id) > -1 : (_vm.filters.excludeSegmentIds)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.filters.excludeSegmentIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = segment.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.filters, "excludeSegmentIds", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.filters, "excludeSegmentIds", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.filters, "excludeSegmentIds", $$c)
          }
        }
      }
    }), _vm._v("\n                      " + _vm._s(segment.queryName) + "\n                      "), _c('span', {
      staticClass: "exclusion-count"
    }, [_vm._v("(" + _vm._s(segment.criteria && segment.criteria.savedUserCount !== undefined ? segment.criteria.savedUserCount : '—') + " users)")])])])
  })], 2), _vm._v(" "), (_vm.filters.excludeSegmentIds.length) ? _c('span', {
    staticClass: "not-enforced-note"
  }, [_vm._v("\n                  These segments are also excluded again at campaign send time.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fg"
  }, [_c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Exclude users currently in an active conversation")]), _vm._v(" "), _c('label', {
    staticClass: "active-conv-toggle",
    class: {
      'active-conv-toggle-on': _vm.filters.activeConversationExclude
    },
    on: {
      "click": _vm.toggleActiveConversationExclude
    }
  }, [_c('span', {
    staticClass: "active-conv-check"
  }, [_vm._v(_vm._s(_vm.filters.activeConversationExclude ? '✓' : ''))]), _vm._v(" "), _c('span', [_vm._v("Exclude users who are currently in an active session for the selected journey")])]), _vm._v(" "), _c('div', {
    staticClass: "fg-sub-note"
  }, [_vm._v("Prevents users from being nudged while already engaged in a conversation. Recommended for all re-engagement campaigns.")])]), _vm._v(" "), _c('div', {
    staticClass: "fg-sub-note",
    staticStyle: {
      "margin-top": "10px",
      "padding-top": "10px",
      "border-top": "1px solid #f0f0f0"
    }
  }, [_vm._v("\n                Frequency cap, cooldown, and STOP opt-outs are always applied automatically before a campaign sends.\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "builder-right"
  }, [_c('div', {
    staticClass: "aud-card"
  }, [_c('div', {
    staticClass: "aud-count-box"
  }, [_c('div', {
    staticClass: "aud-num"
  }, [_vm._v(_vm._s((_vm.audienceCount || 0).toLocaleString()))]), _vm._v(" "), _c('div', [_vm._m(9), _vm._v(" "), (_vm.countStale) ? _c('div', {
    staticClass: "not-enforced-note",
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v("Filters changed since this count — click Get Audience to refresh.")]) : _vm._e(), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "aud-note"
  }, [_vm._v("\n          Frequency cap, 48-hour cooldown, and STOP opt-outs are removed automatically before a campaign sends — the\n          exact per-category breakdown isn't exposed by the counting service used by this screen.\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getAudience
    }
  }, [_vm._v("↻ Refresh count")])]), _vm._v(" "), _c('div', {
    staticClass: "save-card"
  }, [_c('div', {
    staticClass: "save-card-title"
  }, [_vm._v("Save as segment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.segmentName),
      expression: "segmentName"
    }],
    staticClass: "seg-name-input",
    attrs: {
      "type": "text",
      "placeholder": "Segment name"
    },
    domProps: {
      "value": (_vm.segmentName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.segmentName = $event.target.value
      }, function($event) {
        _vm.nameManuallyEdited = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seg-name-auto"
  }, [_vm._v("Auto-generated · editable")]), _vm._v(" "), (_vm.submitted && !_vm.segmentName.trim()) ? _c('span', {
    staticClass: "text-red",
    staticStyle: {
      "display": "block",
      "margin-bottom": "8px"
    }
  }, [_vm._v("Please enter a segment name.")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-pink btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSegment
    }
  }, [_vm._v(_vm._s(_vm.filters.id ? 'Update' : 'Save') + " Segment ›")])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e(), _vm._v(" "), _c('AudienceTable', {
    attrs: {
      "audienceData": _vm.audienceData,
      "audienceCount": _vm.audienceCount,
      "showTable": true,
      "hasRun": _vm.countRun
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Journey "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Platform "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Funnel Stage "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(select the range of stages to include)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Conversation Stage "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(one specific stage in this journey's user reached to)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Entry keyword(s) "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(users who entered via any selected keyword)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Readiness level "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(real answer options detected for this journey's Readiness stage)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Offerings "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(services/products a facility must provide)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fg-lbl"
  }, [_vm._v("Facility "), _c('span', {
    staticClass: "fg-sub"
  }, [_vm._v("(type to search — select one or more facilities in the selected country)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warn-note"
  }, [_c('span', [_vm._v("🧭")]), _vm._v(" "), _c('span', [_vm._v("Matches on the user's referral-capture location or their general location — whichever is within range. Users with neither stored are excluded from the radius match.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aud-lbl"
  }, [_vm._v("users match"), _c('br'), _vm._v("your criteria")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('span', {
    staticClass: "pill pill-green"
  }, [_vm._v("✓ Guardrails applied")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cfa36b42","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/ai-audience/form.vue
// module id = qTps
// module chunks = 1